export default {
    'ERROR-GET-CAMPAIGN-PROSPECTS': {
        'ERROR-CAMPAIGN-ID-INVALID': {
            actionType: 'redirect',
            message: {
                fr: "ID de campagne invalide.",
                en: 'Invalid campaign ID.',
            },
            redirectPath: '/',
        },
    },
    'ERROR-CHECK-PROSPECT': {
        'PROSPECT-ALREADY-EXISTS': {
            actionType: 'toast',
            message: {
                fr: "Le prospect existe déjà dans cette campagne.",
                en: 'Prospect already exists in this campaign.',
            },
        },
        'PROSPECT-MALFORMED': {
            actionType: 'toast',
            message: {
                fr: 'Données du prospect malformées ou incomplètes.',
                en: 'Malformed or incomplete prospect data.',
            },
        },
        'USER-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "L'utilisateur n'a pas été trouvé.",
                en: 'User not found.',
            },
        },
        'TYPE-OF-PROSPECT-UNKNOWN': {
            actionType: 'toast',
            message: {
                fr: "Type de prospect inconnu.",
                en: 'Unknown prospect type.',
            },
        },
    },
    'ERROR-CHECK-PROSPECTS-FILE': {
        'PROSPECTS-ALREADY-MATCHED': {
            actionType: 'toast',
            message: {
                fr: 'Certains prospects sont déjà appariés dans cette campagne.',
                en: 'Some prospects are already matched in this campaign.',
            },
        },
        'PROSPECTS-ALREADY-HELPERS': {
            actionType: 'toast',
            message: {
                fr: 'Certains prospects sont déjà inscrits en tant que ambassadors.',
                en: 'Some prospects are already registered as ambassadeurs.',
            },
        },
        'PROSPECTS-ALREADY-ADMINS': {
            actionType: 'toast',
            message: {
                fr: 'Certains prospects sont déjà des administrateurs.',
                en: 'Some prospects are already administrators.',
            },
        },
        'PROSPECTS-MALFORMED': {
            actionType: 'toast',
            message: {
                fr: 'Certains prospects ont des données malformées ou incomplètes.',
                en: 'Some prospects have malformed or incomplete data.',
            },
        },
    },
    'ERROR-ADD-PROSPECT': {
        'PROSPECT-ALREADY-EXISTS': {
            actionType: 'toast',
            message: {
                fr: 'Le prospect existe déjà dans cette campagne.',
                en: 'Prospect already exists in this campaign.',
            },
        },
        'PROSPECT-MALFORMED': {
            actionType: 'toast',
            message: {
                fr: 'Données du prospect malformées ou incomplètes.',
                en: 'Malformed or incomplete prospect data.',
            },
        },
        'USER-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "L'utilisateur n'a pas été trouvé.",
                en: 'User not found.',
            },
        },
        'TYPE-OF-PROSPECT-UNKNOWN': {
            actionType: 'toast',
            message: {
                fr: "Type de prospect inconnu.",
                en: 'Unknown prospect type.',
            },
        },
    },
    'ERROR-ADD-PROSPECTS-FILE': {
        'PROSPECTS-ALREADY-MATCHED': {
            actionType: 'toast',
            message: {
                fr: 'Certains prospects sont déjà appariés dans cette campagne.',
                en: 'Some prospects are already matched in this campaign.',
            },
        },
        'PROSPECTS-ALREADY-HELPERS': {
            actionType: 'toast',
            message: {
                fr: 'Certains prospects sont déjà inscrits en tant qu\'ambassadeurs.',
                en: 'Some prospects are already registered as ambassadors.',
            },
        },
        'PROSPECTS-ALREADY-ADMINS': {
            actionType: 'toast',
            message: {
                fr: 'Certains prospects sont déjà des administrateurs.',
                en: 'Some prospects are already administrators.',
            },
        },
        'PROSPECTS-MALFORMED': {
            actionType: 'toast',
            message: {
                fr: 'Certains prospects ont des données malformées ou incomplètes.',
                en: 'Some prospects have malformed or incomplete data.',
            },
        },
    },
};
